<template>
  <div class="agent-portal-layout">
    <aside class="sidebar">
      <div class="sidebar-header" @click="goHome">
        <div class="brand-mark">代</div>
        <div class="brand-text">
          <div class="brand-title">代理商后台</div>
          <div class="brand-sub">{{ agentName || '渠道代理商门户' }}</div>
        </div>
      </div>
      <el-menu
        :default-active="activeMenu"
        router
        background-color="#083a34"
        text-color="#c8e6e2"
        active-text-color="#ffffff"
      >
        <el-menu-item index="/agent-portal/workbench">
          <Icon icon="ep:home-filled" class="menu-icon" /><span>工作台</span>
        </el-menu-item>
        <el-menu-item index="/agent-portal/merchants">
          <Icon icon="ep:shop" class="menu-icon" /><span>名下商家</span>
        </el-menu-item>
        <el-menu-item index="/agent-portal/ledger">
          <Icon icon="ep:tickets" class="menu-icon" /><span>分润明细</span>
        </el-menu-item>
        <el-menu-item index="/agent-portal/settle">
          <Icon icon="ep:wallet" class="menu-icon" /><span>结算单</span>
        </el-menu-item>
        <el-menu-item index="/agent-portal/account">
          <Icon icon="ep:credit-card" class="menu-icon" /><span>收款账户</span>
        </el-menu-item>
        <el-menu-item index="/agent-portal/subs">
          <Icon icon="ep:user" class="menu-icon" /><span>二级代理</span>
        </el-menu-item>
      </el-menu>
    </aside>
    <div class="main">
      <div class="header">
        <span class="title">{{ pageTitle }}</span>
        <el-button type="danger" plain size="small" @click="logout">
          <Icon icon="ep:switch-button" class="mr-5px" />退出
        </el-button>
      </div>
      <div class="content"><router-view /></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { clearAgentPortalToken, getAgentPortalToken, portalLogout } from '@/api/agent/portal'

defineOptions({ name: 'AgentPortalLayout' })
const route = useRoute()
const router = useRouter()
const agentName = computed(() => localStorage.getItem('agent_portal_name') || '')
const activeMenu = computed(() => route.path)
const pageTitle = computed(() => (route.meta?.title as string) || '代理商门户')

onMounted(() => {
  if (!getAgentPortalToken() && !route.path.includes('/login')) {
    router.replace('/agent-portal/login')
  }
})

const goHome = () => router.push('/agent-portal/workbench')
const logout = async () => {
  try {
    await portalLogout()
  } catch {}
  clearAgentPortalToken()
  router.replace('/agent-portal/login')
}
</script>

<style scoped lang="scss">
.agent-portal-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
.sidebar {
  width: 228px;
  background: #083a34;
  flex-shrink: 0;
  overflow-y: auto;
  .sidebar-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 18px 16px;
    color: #fff;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
  .brand-mark {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, #0e9c8d, #14b8a6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    flex-shrink: 0;
  }
  .brand-title {
    font-size: 15px;
    font-weight: 700;
    line-height: 1.2;
  }
  .brand-sub {
    margin-top: 2px;
    font-size: 12px;
    color: #9ed7d1;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .menu-icon {
    margin-right: 8px;
  }
  :deep(.el-menu) {
    border-right: none;
  }
  :deep(.el-menu-item.is-active) {
    background: rgba(14, 156, 141, 0.35) !important;
  }
}
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f3f6f8;
  min-width: 0;
}
.header {
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
  }
}
.content {
  flex: 1;
  overflow: auto;
  padding: 16px;
}
</style>
